import { Button, Center, Skeleton, Checkbox } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import PVKDataTableRowFormMeta from '@Modules/interfaceManagement/interface/containers/tableHandlers/bin/pvk/PVKDatatableRowMeta';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { CustomButton } from '@Modules/core/components';

export type TDataTableData = {
    primaryKey: string | number,
    type: string,
    index: string,
    keyA: string,
    keyB: string,
    notes: string,
    usage: string,
    pvk1: string,
    inUse: boolean,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TDataTableData>()

export function getDataTableColumns({ isLoading, handleEdit }: Props) {
  
  return [
    columnHelper.accessor("type",
        {
            id: "type",
            header: "Type",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("index",
        {
            id: "indexId",
            header: "Index",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("keyA",
        {
            id: "keyA",
            header: "Clé value A",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("keyB",
        {
            id: "keyB",
            header: "Clé value B",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("notes",
        {
            id: "notes",
            header: "Notes",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("usage",
        {
            id: "usage",
            header: "Usage",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("pvk1",
        {
            id: "pvk1",
            header: "Pvk1",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("inUse",
        {
            id: "inUse",
            header: "En usage",
            cell: (props) => {               
                return (<Skeleton isLoaded={!isLoading}>
                    <Checkbox checked={!!props.getValue()} readOnly></Checkbox>
                </Skeleton>)
            },
        }
    ),

    columnHelper.display(
        {
            id: "actionBtn",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                            <Button
                                size={'sm'}
                                onClick={() => handleEdit(props.row)}
                                mr={'1rem'}
                            >
                                Editer
                            </Button>
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
